var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("Add "+_vm._s(_vm.action.points)+" points to guest")])
}
var staticRenderFns = []

export { render, staticRenderFns }